(() => {
  const mobile = window.matchMedia('(max-width:749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion:reduce)');
  const init = wrapper => {
    if (wrapper.dataset.tabScrollReady) return;
    const rail = wrapper.querySelector('[data-paw-tab-rail]');
    const prev = wrapper.querySelector('[data-paw-tab-prev]');
    const next = wrapper.querySelector('[data-paw-tab-next]');
    if (!rail || !prev || !next) return;
    wrapper.dataset.tabScrollReady = 'true';
    const position = () => Math.abs(rail.scrollLeft);
    const update = () => {
      const overflow = mobile.matches && rail.scrollWidth > wrapper.clientWidth + 1;
      wrapper.classList.toggle('is-scrollable', overflow);
      const end = Math.max(0, rail.scrollWidth - rail.clientWidth);
      prev.disabled = !overflow || position() < 2;
      next.disabled = !overflow || position() >= end - 2;
    };
    const behavior = () => reducedMotion.matches ? 'auto' : 'smooth';
    const move = direction => {
      const end = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const offset = Math.max(0, Math.min(end, position() + direction * rail.clientWidth * .8));
      const sign = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
      rail.scrollTo({left: sign * offset, behavior: behavior()});
    };
    const reveal = event => {
      if (!mobile.matches) return;
      const tab = event.target.closest('button');
      if (!tab || !rail.contains(tab)) return;
      const bounds = rail.getBoundingClientRect();
      const item = tab.getBoundingClientRect();
      const delta = item.left < bounds.left ? item.left - bounds.left : item.right > bounds.right ? item.right - bounds.right : 0;
      if (delta) rail.scrollBy({left: delta, behavior: behavior()});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, {passive:true});
    rail.addEventListener('focusin', reveal);
    rail.addEventListener('click', reveal);
    const observer = new ResizeObserver(update);
    observer.observe(wrapper);
    observer.observe(rail);
    mobile.addEventListener('change', update);
    const unload = event => {
      if (!event.target.contains(wrapper)) return;
      observer.disconnect();
      mobile.removeEventListener('change', update);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    update();
  };
  const initAll = root => root.querySelectorAll('[data-paw-tab-scroll]').forEach(init);
  initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
